// extracted by mini-css-extract-plugin
export default {"zoomModal":"G2-z"};